module.exports = __webpack_public_path__ + "static/media/Enscape_2022-10-14-22-06-18.947f5690.jpg";